/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsCustomFieldsType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/CustomFieldsPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - custom fields page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsCustomFields: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof PlanSettingsCustomFieldsType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-custom-fields", jiraSpaEntry: "async-plan-settings-custom-fields" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/CustomFieldsPage.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsCustomFields = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsCustomFields}
		pageId="plan-settings-custom-fields"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsCustomFields;
